// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './suspension.scss';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';
import { isMobileOnly } from 'react-device-detect';

class SuspensionPage extends Component {

    render() {
        return (
            <div>
                <PageTitleComponent title={this.props.t("suspension.title")} />
                <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                    <div className='col-1'></div>
                    <div className="col-10"> 
                        <div className="col-12 t-align-center mgt-20">
                            <p><i className="pi pi-exclamation-circle" style={{ fontSize: '2rem', color:'orange' }}></i></p>
                            <span style={{fontSize:'15px'}}>{this.props.t("suspension.message")}</span>
                        </div>         
                    </div>
                    <div className='col-1'></div>
                </div>
            </div>
        );
  }
}

export default (authenticationChecker(withTranslation(SuspensionPage)));